import { Component, OnInit, Input } from '@angular/core';
import { UtilService } from '../../../shared/services';

@Component({
  selector: 'app-medical-causes',
  templateUrl: './medical-causes.component.html',
  styleUrls: ['./medical-causes.component.scss']
})
export class MedicalCausesComponent implements OnInit {

  @Input() section;
  isToggled: boolean;
  textDesc;
  buttonIndex;

  constructor(
    private util: UtilService
  ) { }

  ngOnInit() {
  }

  toggle(cause, i) {
    this.buttonIndex = i;
    if (cause.icon === 'other') {
      this.util.doc.getElementById('leadForm').getElementsByTagName('button')[0].click();
    } else {
      this.textDesc = cause.text_desc;
      Array.prototype.forEach.call(this.section.data_images, item => item.selected = item.icon === cause.icon);
    }
  }

}
